import { DD, DM, DMS, OLC, coordinatesParserSuccessToString, isCoordinatesParserSuccess, parseCoordinates } from "coordinate-formats";
import type { CoordinatesParserSuccess, LatLonTuple } from "coordinate-formats";

export type CoordinateFormatSlug = "dd" | "dm" | "dms" | "olc";

export interface CoordinateSuggestion {
  formatSlug: CoordinateFormatSlug;
  latLon: LatLonTuple;
  label: string;
}

const FORMAT_SLUGS: Record<string, CoordinateFormatSlug> = {
  [DD.format]: "dd",
  [DM.format]: "dm",
  [DMS.format]: "dms",
  [OLC.format]: "olc",
};

const preciseDdToString = DD.makeLatLonToString({ ...DD.defaultStringifyOptions, roundToDigits: 5 });

function suggestionLabel(result: CoordinatesParserSuccess): string {
  if (result.format === DD.format) return preciseDdToString(result.latLon);
  return coordinatesParserSuccessToString(result);
}

export function parseCoordinateSuggestions(term: string): CoordinateSuggestion[] {
  return parseCoordinates(term)
    .filter(isCoordinatesParserSuccess)
    .sort((a, b) => b.probability - a.probability)
    .flatMap((result) => {
      const formatSlug = FORMAT_SLUGS[result.format];
      if (!formatSlug) return [];
      return [{ formatSlug, latLon: result.latLon, label: suggestionLabel(result) }];
    });
}
